import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam'; // post请求体转换方法

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class RegionServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 查询所有数据
  public getRegionAllData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceArea/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public getRegionAllDataManage(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceArea/manage/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 分页查询所有数据
  public getPageAllData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceArea';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addRegionData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceArea';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 删除数据
  public delRegionData(id: string) {
    const url = serverUrl + '/api/spaceManage/spaceArea';
    return this.rSerivce.serverObj.delete(url, {
      params: { idList: id },
    });
  }

  // 修改数据
  public editRegionData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceArea';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 修改绘制数据
  public editRegionDrawData(opts: object) {
    const url = serverUrl + '/api/spaceManage/map/area/draw';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 查询单条数据
  public getRegionDataById(id: any) {
    const url = serverUrl + '/api/spaceManage/spaceArea/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 查询整体区域绘制
  public getRegionDataDetailsAll() {
    const url = serverUrl + '/api/spaceManage/spaceArea/details/all';
    return this.rSerivce.serverObj.get(url);
  }

  // 查询整体区域绘制
  public getRegionDataDetailsAllNew() {
    const url = serverUrl + '/api/spaceManage/map/area/lng/lat/draw';
    return this.rSerivce.serverObj.get(url);
  }

  // 查询整体区域绘制 报警情况
  public getDrawAreaRiskDynamicFactor(opts: object) {
    const url = serverUrl + '/api/yunnan/areaRiskDynamicFactor';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public getRegionDataDetailsById(id: any) {
    const url = serverUrl + '/api/spaceManage/map/area/lng/lat/draw?areaId=' + id;
    return this.rSerivce.serverObj.get(url);
  }

  public getVideoToken() {
    const url = serverUrl + '/api/yunnan/open/ys7/getAccessToken';
    return this.rSerivce.serverObj.get(url);
  }
  // 获取本级及以下区域数据
  public getAreaAndSubAreaList(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceArea/get/AreaAndSubAreaList';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
}
